import { useStore } from '~/store';
import type { GuidelineAxis } from './slice';

/**
 * Source-px centre of the current crop bounds, falling back to the source
 * image centre. Returns null when no source has been loaded yet.
 */
export function guidelineCenter(axis: GuidelineAxis): number | null {
  const { grid, source } = useStore.getState();
  const r = grid.cropRect;
  if (r) return axis === 'v' ? r.x + r.w / 2 : r.y + r.h / 2;
  const d = source.dimensions;
  if (!d) return null;
  return axis === 'v' ? d.w / 2 : d.h / 2;
}
